// frontend/src/api/notificationAPI.js
import axiosInstance from './axiosConfig';

const notificationAPI = {
  list: async ({ onlyUnread = false, limit = 50 } = {}) => {
    const res = await axiosInstance.get('/notifications', {
      params: { onlyUnread: onlyUnread ? 'true' : undefined, limit }
    });
    return res.data;
  },

  unreadCount: async () => {
    const res = await axiosInstance.get('/notifications/unread-count');
    return res.data?.count ?? 0;
  },

  markRead: async (id) => {
    const res = await axiosInstance.post(`/notifications/${id}/read`);
    return res.data;
  },

  markAllRead: async () => {
    const res = await axiosInstance.post('/notifications/read-all');
    return res.data;
  }
};

export default notificationAPI;
